<app-menubar></app-menubar>

<app-dash-calendar></app-dash-calendar>
<div class="competitions-container">
  <app-next-previous-game></app-next-previous-game>
  <app-competitions></app-competitions>
</div>
